import { createContext, useContext, useEffect, useState, type ReactNode } from 'react'
import type { Theme } from '@innerloopco/loopcms-core'
import { useAuth } from '../lib/auth.js'

const ThemeContext = createContext<{ theme: Theme; setTheme: (theme: Theme) => void } | null>(null)

export function ThemeProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth()
  const [theme, setTheme] = useState<Theme>(user?.theme ?? 'dark')

  useEffect(() => {
    if (user?.theme) setTheme(user.theme)
  }, [user?.theme])

  useEffect(() => {
    // The attribute drives both the token overrides and color-scheme, so native
    // scrollbars and form controls follow the theme too.
    document.documentElement.dataset.theme = theme
  }, [theme])

  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>
}

export function useTheme() {
  const value = useContext(ThemeContext)
  if (!value) throw new Error('useTheme must be used inside a ThemeProvider')
  return value
}
